import { Button, Dialog, Flex, Text } from '@servicetitan/anvil2';
import illustration from './email-smooth.svg';
import { SetupDataStore } from '@servicetitan/financing-workflow-shared';
import { DeliveryMethod } from '@servicetitan/financing-api-client';
import { useRedirectToPostApplication } from './redirectToPostApplication';

interface SendLinkConfirmationDialogProps {
    deliveryMethod: DeliveryMethod;
    applicantEmail?: string;
    applicantPhone?: string;
    onReturnToJob: () => void;
    onResendLink?: () => void;
}

export const SendLinkConfirmationDialog = ({
    deliveryMethod,
    applicantEmail,
    applicantPhone,
    onReturnToJob,
    onResendLink,
}: SendLinkConfirmationDialogProps) => {
    const { setupData } = SetupDataStore.useStore();
    const redirectToPostApplication = useRedirectToPostApplication();

    const isEmail = deliveryMethod === DeliveryMethod.Email;
    const recipient = isEmail ? applicantEmail : applicantPhone;
    const deliveryText = isEmail ? 'sent to' : 'sent via text to';
    const isTechnician = setupData?.role === 'technician';
    const isBuyFin = setupData?.provider === 'BuyFin';

    const renderFooterButtons = () => {
        if (isTechnician && isBuyFin) {
            return (
                <Flex direction="column" gap="3" style={{ width: '100%' }}>
                    <Button appearance="primary" style={{ width: '100%' }} onClick={onReturnToJob}>
                        View Estimates
                    </Button>
                    {onResendLink && (
                        <Button
                            appearance="secondary"
                            style={{ width: '100%' }}
                            onClick={onResendLink}
                        >
                            Resend Link
                        </Button>
                    )}
                </Flex>
            );
        } else if (isTechnician) {
            return (
                <Button
                    appearance="primary"
                    style={{ width: '100%' }}
                    onClick={redirectToPostApplication}
                >
                    Continue
                </Button>
            );
        }

        // Homeowner flow: show Return to Proposals
        return (
            <Button appearance="secondary" style={{ width: '100%' }} onClick={onReturnToJob}>
                Return to Proposals
            </Button>
        );
    };

    return (
        <>
            <Dialog.Header />
            <Dialog.Content>
                <Flex direction="column" gap="3" alignItems="center">
                    <img src={illustration} alt="Application sent" width="99" />
                    <Text variant="headline" el="h2">
                        Application sent
                    </Text>
                    <Text variant="body" style={{ textAlign: 'center' }}>
                        A link to complete the {setupData?.provider} application was {deliveryText}{' '}
                        {recipient}. Once the application is complete, you can view its status on
                        the application details page.
                    </Text>
                </Flex>
            </Dialog.Content>
            <Dialog.Footer>{renderFooterButtons()}</Dialog.Footer>
        </>
    );
};
